import { defineMessages } from 'react-intl';
import config from '@plone/volto/registry';
import textCenteredSVG from '@plone/volto/icons/align-center.svg';
import textLeftSVG from '@plone/volto/icons/align-left.svg';
import textRightSVG from '@plone/volto/icons/align-right.svg';

const messages = defineMessages({
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
});

export const headingSchema = (props) => {
  const hide_alignment = config.blocks?.blocksConfig?.heading?.hide_alignment;

  return {
    title: props.intl.formatMessage(messages.heading),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [...(hide_alignment ? [] : ['alignment'])],
      },
    ],

    properties: {
      alignment: {
        title: props.intl.formatMessage(messages.alignment),
        default: 'center',
        required: false,
        type: 'string',
        widget: 'buttons',
        actions: ['left', 'center', 'right'],
        actionsInfoMap: {
          left: [textLeftSVG, props.intl.formatMessage(messages.left)],
          center: [textCenteredSVG, props.intl.formatMessage(messages.center)],
          right: [textRightSVG, props.intl.formatMessage(messages.right)],
        },
      },
    },
    required: [],
  };
};
